// Ad-campaign attribution capture — Feb 9 2026.
// Runs on every page load (mounted at the App root). If the URL carries any
// utm_* / fbclid / gclid param, we:
//   1. Stash a snapshot in localStorage under `ccc_ad_attribution` so the register
//      form can attach it to the new user later (attribution persists across page
//      loads and even browser restarts within the pre-signup window).
//   2. POST /api/ad-visit so admin sees the visitor count regardless of whether
//      they eventually sign up. The endpoint dedupes by session_id within 1 hour
//      so refreshes don't inflate the count.

export const AD_ATTRIBUTION_KEY = 'ccc_ad_attribution';
const SESSION_KEY = 'ccc_ad_session_id';
const ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content',
                    'utm_term', 'fbclid', 'gclid'];

function ensureSessionId() {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = 'lp_' + Math.random().toString(36).slice(2, 14) + Date.now().toString(36);
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

export function captureAdAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    ATTR_KEYS.forEach(k => {
      const v = params.get(k);
      if (v) found[k] = v.slice(0, 200);
    });
    if (Object.keys(found).length === 0) return null;
    // First-touch attribution wins: only overwrite if we don't already have one.
    const existing = localStorage.getItem(AD_ATTRIBUTION_KEY);
    const snapshot = existing ? JSON.parse(existing) : {
      ...found,
      referrer: document.referrer || '',
      landing_path: window.location.pathname,
      first_visit_at: new Date().toISOString(),
    };
    if (!existing) localStorage.setItem(AD_ATTRIBUTION_KEY, JSON.stringify(snapshot));
    // Fire-and-forget visit log to the backend
    const sessionId = ensureSessionId();
    const API = process.env.REACT_APP_BACKEND_URL;
    if (API) {
      fetch(`${API}/api/ad-visit`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...found, referrer: document.referrer || '',
                               landing_path: window.location.pathname,
                               session_id: sessionId }),
      }).catch(() => { /* silent — ad-visit is a nice-to-have */ });
    }
    return snapshot;
  } catch { return null; }
}

export function readAdAttribution() {
  try {
    const raw = localStorage.getItem(AD_ATTRIBUTION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function clearAdAttribution() {
  try { localStorage.removeItem(AD_ATTRIBUTION_KEY); } catch { /* noop */ }
}
